import React from 'react';
import { Icon } from './Icon';
import { Sparkline } from './Sparkline';

/**
 * KPI card. Ported from D:\campaigning-system\src\components\kpi\KpiCard.tsx.
 *
 * Adapted from the prototype's single `stat: KpiStat` prop to discrete props so
 * it composes with the Campaigning Tool's existing metric shapes. `sparkline`
 * and `deltaPct` are optional — the sparkline row and delta pill only render
 * when data is supplied. All styling/geometry is unchanged from the original.
 */
const TONE = {
  teal: { icon: 'bg-cos-teal-faint text-cos-teal-deep', spark: '#0A9188' },
  beige: { icon: 'bg-cos-beige-light text-cos-beige-ink', spark: '#B0872F' },
  neutral: { icon: 'bg-cos-surface-hover text-cos-teal-deep', spark: '#0A9188' },
  // For a figure that means trouble - the only alarming colour the card can wear.
  coral: { icon: 'bg-cos-status-coral/10 text-cos-status-coral', spark: '#A35A4E' },
};

export function KpiCard({ label, value, caption, icon = 'insights', tone = 'teal', deltaPct, sparkline }) {
  const t = TONE[tone] || TONE.teal;
  const up = (deltaPct ?? 0) >= 0;

  return (
    <div className="glass-card glass-interactive p-4">
      <div className="flex items-start justify-between">
        <div className={`grid h-9 w-9 place-items-center rounded-xl ${t.icon}`}>
          <Icon name={icon} className="text-[19px]" weight={500} />
        </div>
        {deltaPct !== undefined && deltaPct !== null && (
          <span
            className={`inline-flex items-center gap-0.5 rounded-full px-1.5 py-0.5 text-2xs font-semibold ${
              up ? 'bg-cos-teal-faint text-cos-teal-deep' : 'bg-cos-status-coral-bg text-cos-status-coral'
            }`}
          >
            <Icon name={up ? 'trending_up' : 'trending_down'} className="text-[14px]" />
            {up ? '+' : ''}
            {deltaPct}%
          </span>
        )}
      </div>

      <div className="mt-3">
        <div className="text-2xs font-semibold uppercase tracking-[0.08em] text-cos-ink-muted">{label}</div>
        <div className="mono mt-0.5 text-[26px] font-bold leading-none tracking-tight text-cos-ink">{value}</div>
      </div>

      {(caption || (sparkline && sparkline.length >= 2)) && (
        <div className="mt-2.5 flex items-end justify-between gap-2">
          <p className="text-[12px] leading-tight text-cos-ink-secondary">{caption}</p>
          {sparkline && sparkline.length >= 2 && (
            <Sparkline data={sparkline} stroke={t.spark} width={72} height={26} />
          )}
        </div>
      )}
    </div>
  );
}

export default KpiCard;
